/*
 * Copyright (c) 2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import RowDataTable from "./RowDataTable.jsx";
import DisplayIcon from "./Icons/DisplayIcon.jsx";
import IconButtonComponent from "./BasicInputs/IconButtonComponent.jsx";
import EmptyStateBig from "./EmptyState/EmptyStateBig.jsx";
import TextElement from "./TextElement.jsx";
import OutputListItem from "./OutputList/OutputListItem.jsx";
import OutputList from "./OutputList/OutputList.jsx";
import DisplayStateHistory from "./DisplayStateHistory.jsx";
import InlineDialog from "./InlineDialog.jsx";
import {BuildServers} from "../Objects/BuildServers.jsx";
import {UI} from "../UIGenerator.jsx";

class BuildServerManagement extends Component {
    constructor() {
        super();
        this.state = {
            allBuildServers: [],
            isLoadedComplete: false,
            selectedBuildServer: null,
            isCreateDialogOpen: false,
            newRegion: null
        }
    }


    async fetchData() {
        let allBuildServers = await BuildServers().listAll()
        this.setState({allBuildServers: allBuildServers ?? [], isLoadedComplete: true})
    }

    componentDidMount() {
        this.fetchData()
    }


    async handleRemove() {
        let {selectedBuildServer} = this.state
        await BuildServers(selectedBuildServer.indexKey).remove()
        await this.fetchData()
        this.setState({selectedBuildServer: null})
    }


    render() {
        let {allBuildServers, selectedBuildServer, isCreateDialogOpen, newRegion} = this.state
        return (
            <div className={"space-y-3"}>

                <RowDataTable
                    selectedIndex={this.state.selectedIndex}
                    iconElement={(row) => {
                        return (<div
                            className={`flex-shrink-0  p-1 flex justify-center items-center rounded  border mr-3 `}>
                            <DisplayIcon iconName={"BuildServer"} size={"1.1rem"}/>
                        </div>)
                    }}
                    buttons={(row) => {
                        return <>
                            {row?.status && (<span
                                className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset ${row.status === "ok" ? "bg-green-50 text-green-700 ring-green-600/20" : "bg-red-50 text-red-700 ring-red-600/20"}`}>{row.status}</span>)}

                            <IconButtonComponent text={`Remove`}
                                                 iconName={"IoTrashOutline"}
                                                 onClick={async () => {
                                                     await BuildServers(row.indexKey).remove()
                                                     await this.fetchData()
                                                 }}/>
                        </>

                    }}
                    data={allBuildServers.map(item => ({
                        ...item,
                        Name: item.name ?? item.indexKey,
                        Description: item.buildServerDomain

                    }))}
                    emptyState={() => {
                        return (<><EmptyStateBig iconName={"BiServer"}
                                                 text={<div className={"w-96 space-y-3"}>
                                                     <TextElement
                                                         textType={"header-lg"}> No build servers found</TextElement>
                                                 </div>}/></>)

                    }}
                    progressPending={!this.state.isLoadedComplete}
                    onRowClicked={(data) => {
                        UI.page().navigate({
                            pathname: "/bs/" + data.indexKey
                        })
                    }}
                    onMiddleMouseClick={(data) => {
                    }}
                />

                <InlineDialog
                    title={"Edit Build Server"}
                    isOpen={selectedBuildServer !== null}
                    button={[{
                        type: "delete", text: "Remove", onClick: async () => {
                            await this.handleRemove()
                        }
                    }, {
                        type: "abort",
                        text: "Abbrechen",
                        onClick: async () => {
                            this.setState({selectedBuildServer: null})
                        }
                    }]}
                    onClose={() => {
                        this.setState({selectedBuildServer: null})
                    }}>
                    <OutputList>
                        <OutputListItem titel={"Name"}>
                            <span>{selectedBuildServer?.name}</span>
                        </OutputListItem>
                        <OutputListItem titel={"BuildServer Id"}>
                            <span>{selectedBuildServer?.indexKey}</span>
                        </OutputListItem>
                        <OutputListItem titel={"buildServerDomain"}>
                            <span>{selectedBuildServer?.buildServerDomain}</span>
                        </OutputListItem>
                        <OutputListItem titel={"Server Id"}>
                            <span>{selectedBuildServer?.serverId}</span>
                        </OutputListItem>
                        <OutputListItem titel={"IPv4"}>
                            <span>{selectedBuildServer?.ipv4}</span>
                        </OutputListItem>
                        <OutputListItem titel={"SSH Port"}>
                            <span>{selectedBuildServer?.sshPort}</span>
                        </OutputListItem>
                        <OutputListItem titel={"Region"}>
                            <span>{selectedBuildServer?.region}</span>
                        </OutputListItem>
                        <OutputListItem titel={"Status"}>
                            <span>{selectedBuildServer?.status}</span>
                        </OutputListItem>
                        <DisplayStateHistory name={"BuildServers"} elementId={selectedBuildServer?.indexKey}/>
                    </OutputList>
                </InlineDialog>


            </div>
        );
    }
}

export default BuildServerManagement;